var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 28 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.753 7.673h-.882l-.221.035c-.092-1.738-.186-2.873-.186-2.873 0-2.324-1.837-4.458-4.357-4.458L14.175.374 7.354.378c-2.52 0-4.375 2.134-4.375 4.458 0 0-.127 1.015-.241 3.029a.842.842 0 0 0-.532-.192h-.902a.864.864 0 0 0-.861.868v3.624c0 .476.384.868.861.868h.901l.349-.079c0 .726-.019 1.497-.019 2.321 0 5.711-.018 12.634-.018 12.634 0 1.072.753 1.718 1.434 1.718h1.341c1.509-.055 1.602-2.273 1.602-2.273h14.763s.13 2.273 1.6 2.273h1.344c.679 0 1.452-.688 1.452-1.823 0 0 .018-7.995-.092-12.253-.019-.844-.057-1.689-.074-2.517h.864a.884.884 0 0 0 .884-.868V8.541a.881.881 0 0 0-.882-.868zM8.77 1.899c0-.23.184-.418.423-.418h9.894c.221 0 .404.188.404.418v1.493a.414.414 0 0 1-.404.419H9.192a.418.418 0 0 1-.423-.419V1.899zm-1.6 23.619c-.955 0-1.728-.807-1.728-1.801 0-.995.772-1.801 1.728-1.801.957 0 1.728.806 1.728 1.801 0 .994-.771 1.801-1.728 1.801zm13.865 0c-.957 0-1.748-.807-1.748-1.801 0-.995.791-1.801 1.748-1.801.938 0 1.728.806 1.728 1.801 0 .994-.79 1.801-1.728 1.801zm1.764-9.378c.02 1.303-.992 1.841-1.985 2.101-2.39.486-3.198.642-6.729.642-4.138 0-6.674-.642-6.674-.642-.901-.221-2.004-.798-1.986-2.101v-5.017c0-2.819.368-4.017.368-4.017 0-1.126.698-2.111 1.985-2.111H20.41c1.308 0 1.857.857 1.988 2.111 0 0 .402 2.024.402 4.734v4.3z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.6e0f60218931fcf79a8a91a881fce58c.svg";
export { ForwardRef as ReactComponent };